export default __webpack_public_path__ + "static/banner-managing-the-reno-budget-what-to-consider-9669abeffbba59edc6182b71d36a266b.jpg";